import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateDeliveryDeviceComponent } from 'app/dialogs/create-delivery-device/create-delivery-device.component';
import { CreateDeviceDialogComponent } from 'app/dialogs/create-device-dialog/create-device-dialog.component';
import { CreateDelivery } from 'app/dtos/Deliveries/createDelivery';
import { CompanyService } from 'app/services/models/company.service';
import { DeliveryMethodService } from 'app/services/models/delivery-method.service';
import { DeliveryService } from 'app/services/models/delivery.service';
import { DeviceService } from 'app/services/models/device.service';
import { PersonService } from 'app/services/models/person.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, from, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-delivery-create',
  templateUrl: './delivery-create.component.html',
  styleUrls: ['./delivery-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeliveryCreateComponent implements OnInit {
  public contentHeader: object;
  companies: any[] = [];
  companyPersons: any[] = [];
  persons: any[] = [];
  transactionManagements: any[] = [];
  deliveryMethods: any[] = [];
  devices: any = [];

  selectedCompanyId: number = null;

  deviceList: any[] = [];

  deliveryForm: FormGroup;

  date = new Date();
  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  constructor(
    private companyService: CompanyService,
    private personService: PersonService,
    private deliveryMethodService: DeliveryMethodService,
    private transactionService: TransactionService,
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    private deliveryService: DeliveryService,
    private router:Router,
    private activatedRouter:ActivatedRoute
  ) {
    this.contentHeader = {
      headerTitle: 'Teslim',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Teslim Listesi',
            isLink: true,
            link: '/admin/delivery'
          },
          {
            name: 'Teslim Oluşturma',
            isLink: false,
          },
        ]
      }
    }
  }


  async ngOnInit() {
    this.deliveryForm = this.fb.group({
      companyId: [null, Validators.required],
      companyPersonId: [null],
      transactionManagementId: [null],
      deliveryDate: [null],
      personId: [null],
      deliveryMethodId: [null, Validators.required],
      deliveryPerson: [null],
      description: [null]
    });
    await this.getAllCompany('');
    await this.getAllPerson(1);
    await this.getAllDeliveryMethod();
    this.activatedRouter.params.subscribe(async params => {
      console.log('URL Params:', params);
      
      if (params['companyId'] != null) {
          const companyId = Number(params['companyId']); // String'i sayıya çevir
          console.log('Gelen CompanyId:', companyId);

          this.deliveryForm.patchValue({
              companyId: companyId
          });

          await this.onCompanySelect(companyId); // Asenkron işlemi beklet
      }
  });
  }

  onSubmit() {
    return false;
  }

  async searchCompany(term: any) {
    console.log(term.term);
    if (!term || term.term.length < 2) {
      this.companies = [];
      return;
    }
    await this.getAllCompany(term.term);
  }

  async getAllCompany(search) {
    const data = await this.companyService.getAllCompany(search, 0, 50);
    console.log(data);
    this.companies = data.companies;
  }

  async onCompanySelect(company: any) {
    console.log("Seçilen Firma ID:", company?.id ?? company);
    this.selectedCompanyId = company.id ?? company;
    this.companyPersons = [];
    this.transactionManagements = [];
    this.devices = [];
    await this.getAllPerson(this.selectedCompanyId);
    await this.getAllCompanyIdTransactionManagement(this.selectedCompanyId);
    
    await this.getAllDevice('', this.selectedCompanyId);
  }

  async getAllPerson(id) {
    const data = await this.personService.getAllCompaniesPersons(0, 50, id);
    console.log(data);
    if (id == 1) {
      this.persons = data.persons;
    } else {
      this.companyPersons = data.persons;
    }
  }

  async getAllCompanyIdTransactionManagement(id) {
    const data = await this.transactionService.getAllTransactionCompany(0, 50, 8, id);
    console.log(data);
    this.transactionManagements = data.transactionManagements;
    this.activatedRouter.params.subscribe(params=>{
      console.log(params);
      if(params['offerId'] != null){
        this.deliveryForm.patchValue({
          transactionManagementId:Number(params['offerId']),
        })
      }
    })
  }

  async getAllDeliveryMethod() {
    const data = await this.deliveryMethodService.getAllDeliveryMethod(0, 100);
    console.log(data);
    this.deliveryMethods = data.deliveryMethods;
  }

  searchDevice = (term: string, item: any) => {
    return (
      item.brandName?.toLowerCase().includes(term.toLowerCase()) ||
      item.modelName?.toLowerCase().includes(term.toLowerCase()) ||
      item.seriNo?.toLowerCase().includes(term.toLowerCase()) ||
      item.typeName?.toLowerCase().includes(term.toLowerCase())
    );
  };

  async getAllDevice(search: string, companyId: number) {
    const data = await this.deviceService.getAllDevices(0, 1000, search, companyId, null, null, null);
    console.log("API'den gelen veri:", data);
    console.log("Cihazlar:", data.devices);
    this.devices = data.devices;
    this.cdRef.detectChanges();
  }

  deviceControl = new FormControl(null);

  onDeviceSelect(event) {
    console.log(event);
    this.showCreateDeliveryDevice(event?.id, `${event.brandName} ${event.modelName} - ${event.seriNo}`, event.companyPersonId, event.companyId);
    this.deviceControl.reset();
  }

  showCreateDeliveryDevice(deviceId, deviceName, companyPersonId, companyId) {
    const modal = this.modalService.open(CreateDeliveryDeviceComponent, {
      windowClass: 'modal modal-success',
      centered: true
    });
    modal.componentInstance.data = {
      id:null,
      deviceId: deviceId,
      deviceName: deviceName,
      companyPersonId: companyPersonId,
      companyId: companyId
    };
    modal.result.then((result) => {
      if (result) {
        const matchedDevice = this.devices.find(device => device.id === result.deviceId);

        // `companies` listesinden companyId ile eşleşeni bul
        const matchedCompany = this.companies.find(company => company.id === result.companyId);

        if (matchedDevice && matchedCompany) {
          const isAlreadyAdded = this.deviceList.some(device => device.id === result.deviceId);

          if (isAlreadyAdded) {
            this.toastrService.error("Bu seri no bir cihaz zaten ekledin.");
            return;
          }
          // Yeni obje oluştur ve deviceList içine ekle
          const newEntry = {
            ...matchedDevice,
            company: matchedCompany // Şirket bilgilerini de objeye ekle
          };

          this.deviceList.push(newEntry);
          console.log('Güncellenmiş Device List:', this.deviceList);
        }

      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);

    });
  }

  showCreateDeviceDialog() {
    const modal = this.modalService.open(CreateDeviceDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      companyId: this.selectedCompanyId
    };
    modal.result.then(async (newDeviceIds) => {
      if (newDeviceIds && newDeviceIds.length > 0) {

        await this.getAllDevice('', this.selectedCompanyId);


        newDeviceIds.forEach(element => {
          console.log(element);
          const matchedDevice = this.devices.find(device => device.id === element);

          this.showCreateDeliveryDevice(matchedDevice.id,matchedDevice.name,null,this.selectedCompanyId);
         /* const matchedCompany = this.companies.find(company => company.id === this.selectedCompanyId);
          const newEntry = {
            ...matchedDevice,
            company: matchedCompany // Şirket bilgilerini de objeye ekle
          };*/
          //this.deviceList.push(newEntry);
          //console.log('Güncellenmiş Device List:', this.deviceList);
        });
      }
    })
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return `Oluşturuldu`;
      case 2:
        return `İptal Edildi`;
      case 3:
        return `Onaylandı`;
      case 4:
        return `Reddedildi`;
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  async onSumbit() {
    console.log(this.deliveryForm.value);
    console.log(this.deviceList);

    const formData = this.deliveryForm.value;

    const createDeliveryDevices = this.deviceList.map(device => ({
      deviceId: device.id,
      deliveryId: 0, // Yeni oluşturulacak, varsayılan 0
      deviceAcceptanceStatesId: 1, // Varsayılan değer
      deliveryDate: null,
      deliveryMethodId: null,
      companyId: device.company.id, // Şirket ID'yi formdan al
      deliveryPerson: null,
      isDeliveryStatus: false,
      personId: null,
      deliveryCompanyPersonId: null
    }));

    const createDelivery: CreateDelivery = {
      companyId: formData.companyId,
      transactionManagementId: formData.transactionManagementId,
      deliveryPerson: formData.deliveryPerson,
      personId: formData.personId,
      companyPersonId: formData.companyPersonId,
      deliveryDate: formData.deliveryDate[0], // Flatpickr'den gelen tarih array, ilk elemanı al
      deliveryMethodId: formData.deliveryMethodId,
      description: formData.description,
      createDeliveryDevices: createDeliveryDevices
    };

    const data = await this.deliveryService.createDeliveries(createDelivery);
    if (data.status) {
      this.router.navigate(["/admin/delivery"])
      this.toastrService.success(data.message);
    } else {
      this.toastrService.error(data.message);
    }
  }

  async removeDeliveryDevice(id: number) {
    const index = this.deviceList.findIndex(device => device.id === id);
    if (index !== -1) {
      this.deviceList.splice(index, 1);
    }
  }
}